var canvas, config, ctx, model;

model = require('./model');

config = require('./config');

canvas = document.querySelector('canvas');

ctx = canvas.getContext('2d');

ctx.textAlign = 'center';

ctx.textBaseline = 'middle';

model.on('change', function() {
  var char, drop, from, h, i, index, len, pos, results, slot, slots, to, w, x, y;
  w = window.innerWidth;
  h = window.innerHeight;
  canvas.width = w;
  canvas.height = h;
  ctx.font = config.fontSize + "px Optima";
  ctx.clearRect(0, 0, w, h);
  slots = model.getSlots();
  results = [];
  for (index = i = 0, len = slots.length; i < len; index = ++i) {
    slot = slots[index];
    results.push((function() {
      var j, len1, ref, results1;
      ref = slot.drops;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        drop = ref[j];
        x = (index + 0.5) * config.width;
        from = Math.max(0, drop.head - drop.length + 1);
        to = Math.min(slot.size, drop.head);
        results1.push((function() {
          var k, ref1, ref2, results2;
          results2 = [];
          for (pos = k = ref1 = from, ref2 = to; ref1 <= ref2 ? k < ref2 : k > ref2; pos = ref1 <= ref2 ? ++k : --k) {
            y = (pos + 0.5) * config.width;
            char = drop.text[pos];
            if ((pos + 2) > drop.head) {
              ctx.fillStyle = config.bright;
            } else {
              ctx.fillStyle = config.color;
            }
            results2.push(ctx.fillText(char, x, y));
          }
          return results2;
        })());
      }
      return results1;
    })());
  }
  return results;
});
